export default {
  title: 'Languages',
  language: 'Language',
  basicSetting: 'Basic settings',

  labels: {
    basicSetting: 'Base setting',
    defaultLanguage: 'Language',
    defaultCurrency: 'Currency',
    region: 'Region',
    defaultCountryCode: 'Country code'
  },

  currency: {
    IRT: 'IRT',
    IRR: 'IRR',
    USD: 'USD',
    AED: 'AED',
    other: 'other'
  },

  notifications: {
    edit: {
      success: 'Locale setting was successfully edited',
      error: 'Edit locale setting has error'
    }
  },

  confirmations: {
    changeLanguage: {
      title: 'Edit language confirmation',
      body: 'Do you want to continue with this language?',
      dangerText: 'Your language is not same with selected lang and your language will change, '
    }
  }
}
